export default __webpack_public_path__ + "static/photon_einstein-1fd87ddcf5f546230059cf1bc8e281db.svg";